import { Breadcrumb, Button, Card, Form, Row, Steps } from 'antd'
import Members from 'api/Members'
import Suppliers from 'api/Purchase/Suppliers'
import useSubmit from 'elements/Hooks/useSubmit'
import { isEmpty, omit, pick } from 'lodash'
import { message } from 'antd'
import moment from 'moment'
import { checkForm } from 'modules/Utils'
import React, { Fragment, useRef, useState } from 'react'
import PersonalDetailsForm from './Form/ContactDetails'
import Existing from './Form/Existing'
import style from './style.css'

const Step = Steps.Step
const api = new Suppliers()
const membersApi = new Members()

function NewSupplier(props) {
  const [current, setCurrent] = useState(0)
  const [member, setMember] = useState(null)

  console.log('member', isEmpty(member))
  // state = {loading: false, current: 0, submitting: false}
  //

  const formRef = useRef()
  const [submitting, updateFunc] = useSubmit(api.update)
  const [creating, createFunc] = useSubmit(api.create)
  const [submittingMember, memberFunc] = useSubmit(membersApi.create)
  const submit = async () => {
    const values = await checkForm(formRef)
    console.log(values)

    let newData = {
      ...values,
      code: 'DRAFT-' + Math.round(new Date().getTime() / 1000),
      type: 'supplier',
      date: { registration: moment().utc().format() },
    }
    let result

    if (member.new === true) {
      newData = omit(newData, ['new'])

      const memberDB = await memberFunc(values)
      console.log(memberDB)

      newData.owner = memberDB[0]._id
      result = await createFunc({ ...newData, member })
      console.log(result)
    } else {
      newData.owner = member._id
      result = await createFunc({ ...newData, member })
      console.log(result)
    }

    result &&
      message.success('Created!') &&
      setTimeout(() => {
        const pathname = '/purchasing/suppliers/list/'
        window.location = `#${pathname}`
      }, 300)
  }
  const prev = () => setCurrent((e) => e - 1)
  const next = () => setCurrent((e) => e + 1)

  // submit = async () => {
  //   let valid = false
  //   try {
  //     valid = await checkPersonalDetailsForm()
  //     if (valid) {
  //       setState({
  //         submitting: true,
  //       })
  //       props.form.validateFieldsAndScroll(async (err, values) => {
  //         if (!err) {

  //           try {
  //             if (member.new === true) {
  //               member = _.omit(member, ['new'])
  //               member.kind = 'individual'
  //               const response = await membersApi.create(member)
  //               const memberDB = await response.json()
  //               supplier.owner = memberDB[0]._id
  //               result = await api.create(supplier)
  //             } else {
  //               await membersApi.update(member)
  //               supplier.owner = member._id
  //               result = await api.create(supplier)
  //             }
  //             result &&
  //               (message.success('Created!') &&
  //                 setTimeout(() => {
  //                   const pathname = '/purchasing/suppliers/list/'
  //                   window.location = `#${pathname}`
  //                 }, 300))
  //           } catch (error) {
  //             message.error(error.errorMessage)
  //             setState({submitting: false})
  //           }
  //         }
  //         setState({submitting: false})
  //       })
  //     }
  //   } catch (error) {
  //     console.error(error)
  //     message.error(error.errorMessage)
  //     setState({submitting: false})
  //   }
  // }
  // checkExistingForm = () => {
  //   return new Promise((res, rej) => {
  //     try {
  //       const member = ExistingCmp.validate()
  //       setState({
  //         member,
  //       })
  //       res(true)
  //     } catch (err) {
  //       message.error(err)
  //     }
  //   })
  // }
  //
  // checkPersonalDetailsForm = () => {
  //   return new Promise((res, rej) => {
  //     PersonalDetailsFormCmp.validateFields((err, values) => {
  //       if (!err) {
  //         const member = _.pick(member, [
  //           '_id',
  //           '_rev',
  //           '_key',
  //           'new',
  //         ])
  //         setState({member: Object.assign({}, member, values)})
  //         res(true)
  //       }
  //     })
  //   })
  // }

  const steps = [
    {
      title: 'Existing Member',
      content: <Existing setMember={setMember} />,
    },
    {
      title: 'Personal Details',
      content: <PersonalDetailsForm ref={formRef} member={member} />,
    },
  ]

  return (
    <div className="flex flex-col">
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="#/purchasing/suppliers/list">Vendor List</Breadcrumb.Item>
            <Breadcrumb.Item>New Supplier</Breadcrumb.Item>
          </Breadcrumb>
          <h2 className={style.title}>Create new Supplier</h2>
          <p className={style.paragraph}>
            You can either add new supplier or select an individual from existing contact.
          </p>
        </Row>
      </Card>
      <div className="mt-10 bg-red-200 w-full flex flex-col bg-white mx-auto p-10">
        <Steps current={current}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div className="steps-content">{steps[current].content}</div>
        <div
          className="steps-action"
          style={{
            textAlign: 'center',
            paddingTop: 20,
          }}>
          {current > 0 && (
            <Button style={{ marginRight: 8 }} onClick={prev}>
              Previous
            </Button>
          )}
          {current === 0 && (
            <Button
              style={{
                width: '100px',
                marginRight: 8,
              }}
              onClick={() => {
                setCurrent(1)
                setMember({ new: true })
              }}>
              Skip
            </Button>
          )}
          {current < steps.length - 1 && (
            <Button style={{ width: '100px' }} disabled={isEmpty(member)} type="primary" onClick={next}>
              Next
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button type="primary" loading={submitting || creating || submittingMember} onClick={submit}>
              Create
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default Form.create()(NewSupplier)
